import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import Checkbox from "../../../atoms/input/checkbox";
import GrayBtn from "../../../atoms/button/grayBtn";
import PretendardText from "../../../atoms/text/pretendardText";
import MemberApi from "../../../../api/member.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../../util/toastMsg";
import { errorHandler } from "../../../../util/errorHandler";

const WritableSet = ({
  userCheckedIdList,
  getMemberList,
  sessionStorageInit,
  setButtonGroupOpen,
  setButtonGroupFilterOpen,
}) => {
  const navigate = useNavigate();
  const [alarmFlag, setAlarmFlag] = useState(false);

  const [writableList, setWritableList] = useState([
    { title: "커뮤니티 공지사항", value: 3 },
    { title: "커뮤니티 알림&이벤트", value: 14 },
    { title: "커뮤니티 신규멤버 필독", value: 15 },
    { title: "커뮤니티 명예의 전당", value: 6 },
    { title: "커뮤니티 글쓰기 고수 칼럼", value: 7 },
    { title: "크루전용 자료창고", value: -1 },
  ]);

  const [selectedIdList, setSelectedIdList] = useState([]);

  useEffect(() => {
    if (userCheckedIdList?.length === 1) {
      setSelectedIdList(userCheckedIdList[0].writableCategoryIdList);
    }
  }, [userCheckedIdList]);

  const writableSettingFunc = async () => {
    try {
      let memberIdsTemp = userCheckedIdList.map((item) => item.id);

      const data = {
        memberIds: memberIdsTemp,
        writableCategoryIdList: selectedIdList,
        alarmFlag: alarmFlag,
      };

      await MemberApi.writableSetting(data);

      getMemberList();
      toast(toastMsg.create);
      setButtonGroupOpen(false);
      sessionStorageInit();
    } catch (error) {
      errorHandler(error);
    }
  };

  const clickedFunc = (value) => {
    if (selectedIdList.some((item02) => item02 === value)) {
      let idListTemp = selectedIdList.filter((item02) => item02 !== value);

      setSelectedIdList(idListTemp);
    } else {
      setSelectedIdList([...selectedIdList, value]);
    }
  };

  return (
    <FilterWrapper
      style={{
        width: 370,
        top: 36,
        padding: 16,
      }}
    >
      <FilterTitle
        style={{
          marginBottom: 10,
        }}
      >
        글쓰기 권한을 부여할 카테고리
      </FilterTitle>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {writableList.map((item, index) => {
          return (
            <CheckboxWrapper
              key={index}
              onClick={() => {
                clickedFunc(item.value);
              }}
            >
              <Checkbox
                checked={selectedIdList.some((item02) => item02 === item.value)}
                onChange={() => {
                  clickedFunc(item.value);
                }}
              />
              <CheckboxText
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  lineHeight: "21.5px",
                  color: "#aaa",
                }}
              >
                {item.title}
              </CheckboxText>
            </CheckboxWrapper>
          );
        })}
      </div>
      <span
        style={{
          display: "block",
          width: "100%",
          height: 0.5,
          background: "rgba(255, 255, 255, 0.12)",
          marginTop: 10,
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "10px 0px 16px 0px",
          gap: 12,
        }}
      >
        <CheckboxWrapper
          onClick={() => {
            setAlarmFlag(!alarmFlag);
          }}
        >
          <Checkbox
            checked={alarmFlag}
            onChange={() => {
              setAlarmFlag(!alarmFlag);
            }}
          />
          <CheckboxText
            style={{
              fontSize: "15px",
              fontWeight: "500",
              lineHeight: "21.5px",
              color: "#aaa",
            }}
          >
            알림 전송하기
          </CheckboxText>
        </CheckboxWrapper>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 8,
        }}
      >
        <GrayBtn
          style={{
            backgroundColor: "#313233",
          }}
          onClick={() => {
            setButtonGroupFilterOpen((prev) => ({
              ...Object.keys(prev).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
              ),
              write: !prev.write,
            }));
          }}
        >
          취소
        </GrayBtn>
        <GrayBtn
          style={{
            backgroundColor: "#313233",
          }}
          onClick={() => {
            writableSettingFunc();

            setButtonGroupFilterOpen({
              group: false,
              gradeAndLevel: false,
              point: false,
              coupon: false,
              read: false,
              write: false,
            });
          }}
        >
          적용
        </GrayBtn>
      </div>
    </FilterWrapper>
  );
};

export default WritableSet;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;

  cursor: pointer;
`;
